import { oc } from 'ts-optchain';
import _ from 'lodash';

import { StoreType } from '@tock/shared/utils/connect';
import { dashboard } from 'types';
import { safeEnumCompare } from '@tock/coretypes';
import protos from 'utils/protos';

const { ExternalSystemType } = protos;

export function shouldSendPartyStatusUpdates(state: StoreType) {
  return _.some(
    oc(state.pointOfSale).connectedSystems([]),
    (externalSystem) =>
      safeEnumCompare(externalSystem.system, ExternalSystemType, ExternalSystemType.TOAST) ||
      safeEnumCompare(externalSystem.system, ExternalSystemType, ExternalSystemType.LIGHTSPEED)
  );
}

export const posSystemsWithSkuMapping: dashboard.ExternalSystemType[] = [
  'BLOYAL',
  'COMMERCE7',
  'DYNAMICS_365',
  'TOAST',
  'WINEDIRECT_CLASSIC',
];
